import enUS from '../../.octopus/en-US/index.js';

export default {
  TntdNewReference: enUS,
};
